import * as React from 'react'
import { PickingListCalculationRowShape, StagedPick } from '../../api/api_data_types'

interface PickingListQuantityInputProps {
  row: PickingListCalculationRowShape
  changedQuantities: Record<string, StagedPick>
  setChangedQuantities: React.Dispatch<React.SetStateAction<Record<string, StagedPick>>>
}

export default function PickingListQuantityInput({
  row,
  changedQuantities,
  setChangedQuantities,
}: PickingListQuantityInputProps) {
  const itemId = row.item?.id

  if (row.submitted || itemId == null) {
    return (
      <>
        <input
          className="form-control consumption-line-quantity-field"
          type="number"
          value={row.submitted ? Number(row.submitted_quantity) : 0}
          title={row.submitted ? undefined : 'Ukendt vare'}
          disabled
          readOnly
        />
        {!row.submitted && <small className="text-muted d-block">ukendt vare</small>}
      </>
    )
  }

  const key = row.key
  const changed = changedQuantities[key]
  const isChanged = changed !== undefined
  const value = isChanged ? changed.quantity : 0

  const onChange = (e) => {
    const quantity = e.target.value
    if (Number(quantity) === 0) {
      setChangedQuantities((current) => {
        const next = { ...current }
        delete next[key]
        return next
      })
    } else {
      setChangedQuantities((current) => ({
        ...current,
        [key]: { item_no: row.item_no, quantity, item_id: itemId },
      }))
    }
  }

  const className = `form-control consumption-line-quantity-field${isChanged ? ' is-changed' : ''}`

  return <input className={className} type="number" step={0.1} value={value} onChange={onChange} />
}
